var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "team-fraction" },
    [
      _c("show-lx-record", { ref: "lxRecord" }, [
        _vm._v(" " + _vm._s(_vm.$t("teamFraction.CKCJ")) + " "),
        _c(
          "div",
          {
            staticClass: "header-center",
            attrs: { slot: "header-center" },
            slot: "header-center",
          },
          [
            _c("img", {
              attrs: { src: require("@/assets/image/team-left.png") },
              on: {
                click: () => {
                  _vm.toolgTeam("prev")
                },
              },
            }),
            _c("span", [_vm._v(_vm._s(_vm.titleData.curTeamName))]),
            _c("img", {
              attrs: { src: require("@/assets/image/team-right.png") },
              on: {
                click: () => {
                  _vm.toolgTeam("next")
                },
              },
            }),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }